import { Link } from "react-router-dom";
import { AppLayout } from "@/components/layouts/AppLayout";

const NotFound = () => {
  return (
    <AppLayout>
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold text-primary">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
          <Link to="/clients" className="text-primary underline hover:text-primary/90">
            Return to Clients
          </Link>
        </div>
      </div>
    </AppLayout>
  );
};

export default NotFound;
